import "../styles/adminContactStyles.css";
const SearchBar = ({ filters, setFilters, onSearch }) => {

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  return (
    <>
        <div style={{display:'flex', flexDirection: 'row', marginLeft:'2px',marginTop:'4px'}}>
          <div className="search-label">
          <label className="control-label">Name:</label>
        </div>

        <div className="search-input">
          <input
            type="text"
            className="form-control"
            value={filters.name}
            onChange={(e) =>
              setFilters(prev => ({ ...prev, name: e.target.value }))
            }
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="search-label " style={{marginLeft:'18px'}}>
          <label className="control-label">Email:</label>
        </div>

        <div className="search-input ">
          <input
            type="text"
            className="form-control"
            value={filters.email}
            onChange={(e) =>
              setFilters(prev => ({ ...prev, email: e.target.value }))
            }
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="col-sm-2">
          <button
            className="btn btn-primary btnPrimary"
            onClick={onSearch}
          >
            Go
          </button>
        </div>
        </div>
        </>
  );
};

export default SearchBar;